import React, { useContext, useEffect } from 'react';
import { Button, Segment, Grid, Divider, Header, Icon, Rail, Container, Popup, } from 'semantic-ui-react';
import MinorStore from '../../../app/stores/minorStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Link } from 'react-router-dom';
import MinorTab from './MinorTab';
import MinorNotesFeed from './MinorNotesFeed';

interface DetailParams {
  id: string;
}

const MinorDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const minorStore = useContext(MinorStore);
  const { project, loadProject, loadProjectNotes, loadTechnicians, 
    loadProjectDocuments, loadingInitial, clearPage} = minorStore;

  useEffect(() => {
    loadProject(match.params.id);
    loadProjectNotes(match.params.id);
    loadTechnicians();
    loadProjectDocuments(match.params.id);
    
    return () => {
      clearPage();
    };
  }, []);

  if (loadingInitial || !project) return <LoadingComponent content='Loading Project ...' /> 
  
  return (
    <Segment style={{marginRight: "22rem"}}>
      <Grid>
        <Grid.Column width={2} textAlign="right">
          <span style={{ color: "blue", fontSize: 16 }}>Project Code:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Address:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Remark:</span>
          <br></br>
        </Grid.Column>
        <Grid.Column width={6}>
          <span style={{ fontSize: 16 }}>{project.projectCode}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>{project.address}</span>
          <Popup
              content="Open in google map"
              trigger={
                  <a href={`https://maps.google.com/?q=${project.address}`} target="_Blank">
                    <Icon name='map marker alternate' size='large'/>
                  </a>
                      }
            />
          <br></br>
          <span style={{ fontSize: 16 }}>{project.remark}</span>
          <br></br>
        </Grid.Column>
        <Grid.Column width={4} textAlign="right">
          <span style={{ color: "blue", fontSize: 16 }}>Status:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Work Type:</span>
          <br></br>   
          <span style={{ color: "blue", fontSize: 16 }}>Subcon Payment:</span>
          <br></br> 
        </Grid.Column>
        <Grid.Column width={4}>
          <span style={{ fontSize: 16 }}><strong>{project.status}</strong></span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {project.workType}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {project.orderNumber}
          </span>
          <br></br>
          <Button
            onClick={() => history.push("/projectmanagement/minor")}
            color="grey"
            floated="right"
            content="Cancel"
          />
          <Button
            as={Link}
            to={`/projectmanagement/minor-edit/${project.id}`}
            color="blue"
            floated="right"
            content="Edit"
          />
        </Grid.Column>
      </Grid>
      <Divider horizontal >
      <Header as='h4'>
        <Icon name='arrow alternate circle down' />
        Details
      </Header>
    </Divider>
    <MinorTab/>
    <Rail position='right' attached style={{width: "22rem"}}>
          <MinorNotesFeed/>
        </Rail>
    </Segment>
  );
};

export default observer(MinorDetails);
